function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/*=============================================================================
 * Copyright (C) 2016,2018 Stephen F. Norledge and Alces Flight Ltd.
 *
 * This file is part of Alces Prime.
 *
 * All rights reserved, see LICENSE.txt.
 *===========================================================================*/

/*=============================================================================
 * Based on code taken from
 * https://github.com/dixieio/redux-json-api/blob/master/src/state-mutation.js
 * under the MIT license.
 * https://github.com/dixieio/redux-json-api/blob/master/package.json
 *===========================================================================*/


import { find, get, has, hasIn, isPlainObject, reduce } from 'lodash';
import pluralize from 'pluralize';
import { static as Immutable } from 'seamless-immutable'; // Useful utilities missing from seamless-immutable.

function mergeIn(object, path, patches, options) {
  return Immutable.updateIn(object, path, function (currentValue) {
    return currentValue ? Immutable.merge(currentValue, patches, options) : Immutable(patches);
  });
}

function withoutIn(object, path, attribute) {
  return Immutable.updateIn(object, path, function (currentEntity) {
    return Immutable.without(currentEntity, attribute);
  });
}

var pathToEntity = function pathToEntity(entity) {
  return [entity.type, 'data', entity.id];
};

var pathToEntityClientMeta = function pathToEntityClientMeta(entity) {
  return pathToEntity(entity).concat(['meta', 'client']);
};

var pathToEntityRelationships = function pathToEntityRelationships(entity) {
  return pathToEntity(entity).concat(['relationships']);
};

var removeEntityFromRelation = function removeEntityFromRelation(entity, relationLinkageData) {
  if (relationLinkageData === undefined) {
    // If we've not yet loaded the linkage data from the server, we don't
    // create it here.
    return relationLinkageData;
  }

  return relationLinkageData.filter(function (item) {
    return item.type !== entity.type || item.id !== entity.id;
  });
};

var addEntityToRelation = function addEntityToRelation(entity, relationLinkageData) {
  if (relationLinkageData === undefined) {
    // If we've not yet loaded the linkage data from the server, we don't
    // create it here.
    return relationLinkageData;
  }

  if (find(relationLinkageData, entity)) {
    return relationLinkageData;
  }

  return relationLinkageData.concat(entity);
};

var updateReverseRelationship = function updateReverseRelationship(entity, relationship) {
  var newRelation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    type: entity.type,
    id: entity.id
  };
  return function (foreignEntities) {
    if (!has(foreignEntities, get(relationship, ['data', 'id']))) {
      return foreignEntities;
    }

    return Immutable.update(foreignEntities, get(relationship, ['data', 'id']), function (foreignEntity) {
      var _map = [1, 2].map(function (i) {
        return pluralize(entity.type, i);
      }),
          _map2 = _slicedToArray(_map, 2),
          singular = _map2[0],
          plural = _map2[1];

      var relCase = [singular, plural].find(function (r) {
        return hasIn(foreignEntity, ['relationships', r]);
      });

      if (!relCase) {
        return foreignEntity;
      }

      return Immutable.updateIn(foreignEntity, ['relationships', relCase, 'data'], function (relationLinkageData) {
        if (relCase === singular) {
          return newRelation;
        }

        if (newRelation == null) {
          return removeEntityFromRelation(entity, relationLinkageData);
        }

        return addEntityToRelation(newRelation, relationLinkageData);
      });
    });
  };
};

var updateOrInsertEntityKeepingClientMeta = function updateOrInsertEntityKeepingClientMeta(state, entity) {
  var existingClientMetaPath = pathToEntityClientMeta(entity);
  var newStateWithoutClientMeta = mergeIn(state, pathToEntity(entity), entity, {
    deep: true
  });
  var existingClientMeta = get(state, existingClientMetaPath);

  if (existingClientMeta != null) {
    return mergeIn(newStateWithoutClientMeta, existingClientMetaPath, existingClientMeta);
  }

  return newStateWithoutClientMeta;
};

var updateOrInsertEntity = function updateOrInsertEntity(state, entity) {
  if (isPlainObject(entity) === false) {
    return state;
  }

  var newState = updateOrInsertEntityKeepingClientMeta(state, entity);
  var rels = entity.relationships;

  if (!rels) {
    return newState;
  }

  return reduce(rels, function (s, relationship) {
    var relatedEntitiesPath = [get(relationship, ['data', 'type']), 'data'];

    if (hasIn(s, relatedEntitiesPath) === false) {
      return s;
    }

    return Immutable.updateIn(s, relatedEntitiesPath, updateReverseRelationship(entity, relationship));
  }, newState);
};

export var removeEntityFromState = function removeEntityFromState(state, entity) {
  var newState = withoutIn(state, [entity.type, 'data'], entity.id);
  var rels = entity.relationships;

  if (!rels) {
    return newState;
  }

  return reduce(rels, function (s, relationship) {
    var entityPath = [get(relationship, ['data', 'type']), 'data'];

    if (hasIn(s, entityPath) === false) {
      return s;
    }

    return Immutable.updateIn(s, entityPath, updateReverseRelationship(entity, relationship, null));
  }, newState);
};
export var removeEntitiesFromState = function removeEntitiesFromState(state, entityType) {
  var entities = get(state, [entityType, 'data']);
  return reduce(entities, removeEntityFromState, state);
};
export var updateOrInsertEntitiesIntoState = function updateOrInsertEntitiesIntoState(state, entities) {
  return reduce(entities, updateOrInsertEntity, state);
};
export var patchMeta = function patchMeta(state, entity, metaPatches) {
  if (entity.id == null) {
    return state;
  }

  return mergeIn(state, pathToEntityClientMeta(entity), metaPatches, {
    deep: true
  });
};
export var patchLinksData = function patchLinksData(state, entity, linksPatches) {
  return mergeIn(state, pathToEntityRelationships(entity), linksPatches, {
    deep: true
  });
};